/**
 * Main entry — imports the active theme's CSS + all JS modules.
 * The '@theme-entry' alias is resolved by vite.config.js
 * to src/scss/themes/{THEME}/entry.scss based on --mode flag.
 */

import '@theme-entry';
import { initNavbar }  from './components/menu.js';
import { initForms }   from './components/forms.js';
import { initGallery } from './components/gallery.js';

document.addEventListener('DOMContentLoaded', () => {
  initNavbar();
  initForms();
  initGallery();
});
